import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import BlogSection from "../components/ArticlesSection";

const Blog = () => {
  return (
    <div className="Blog">
      <Navbar />
      <BlogSection />
    </div>
  );
};

export default Blog;
